const categoryHeadline = $('#category-headline');
const breadcrumbTitle = $('#selected-breadcrumb')
const mainView = $('#help-center-overview');
const categoryView = $('#help-center-main');

// Functions
function changeCategory(e) {
    let newCategoryTitle = e.attr('data-title');
    let newCategoryHandle = e.attr('data-category');
    let btnToSetActive = $(`.help-center-button[data-category="${newCategoryHandle}"]`);
    let categoryItemsToShow = $(`.content-block[data-category="${newCategoryHandle}"]`)
    
    $(`.help-center-button`).removeClass('active');
    $(`.content-block`).addClass('hideContent').removeClass('openItem');
    
    btnToSetActive.addClass('active');

    if(newCategoryHandle == 'all') {
        $('.content-block:not(#noResults):not(#contactForm)').removeClass('hideContent');
    }
    else {
        categoryItemsToShow.removeClass('hideContent');
    }

    categoryHeadline.html(newCategoryTitle);
    breadcrumbTitle.html(newCategoryTitle);

    var firstHeight = $(`.content-block:not(#contactForm):not(#noResults):not(.hideContent):first .content-block-content`).attr('data-height');


    $(`.content-block:not(#contactForm):not(#noResults):not(.hideContent):first`).removeClass('hideContent').addClass('openItem stopTransition');
  
    $('.content-block-content-outer').css("max-height", '0px');
    $(`.content-block:not(#contactForm):not(#noResults):not(.hideContent):first .content-block-content-outer`).css("max-height", `${parseInt(firstHeight) + 20}px`);

    setTimeout(() => {
        $(`.content-block:not(#contactForm):not(#noResults):not(.hideContent):first`).removeClass('stopTransition');
      }, "300");


}

function backToMain() {
    categoryView.addClass('hideView');
    mainView.removeClass('hideView');
}

function showCategoryView() {
    mainView.addClass('hideView');
    categoryView.removeClass('hideView');
}

function scrollToTop() {
    $(".help-center-main")[0].scrollIntoView({
        behavior: "smooth",
        block: "start" 
    });
}

function resizeFAQ() {
  if($(".content-block-content").length > 0) {
    $(".content-block-content").each(function(e) {
        let height = $(this).height();
        $(this).attr('data-height', height)
    });
  }
}

function openFaq(e) {
    $(`.content-block`).not(e).removeClass('openItem');
    $('.content-block-content-outer').css('max-height', `0px`)

    if(e.hasClass('openItem')) {
        e.removeClass('openItem');
        e.find('.content-block-content-outer').css('max-height', `0px`)
    }
    else {
        e.addClass('openItem');
        let height = e.find('.content-block-content').attr('data-height');
        e.find('.content-block-content-outer').css('max-height', `${height}px`)
    }
}

function updateInputAndSearch(e) {

    if(mainView.is(':visible')) {
        showCategoryView();
    }

    let val = $(e).val();

    if(!$('[data-category="all"]').hasClass('active')) {
        $('[data-category="all"]').click();
    }   

    if(!val) {
        categoryHeadline.html('All FAQs');
        $('#noResults').addClass('hideContent');
        $('.content-block:not(#noResults):not(#contactForm)').removeClass('hideContent');
    }
    else {
    categoryHeadline.html(`Results for '${val}'`);

    $('.content-block:not(#noResults):not(#contactForm)').each(function(){
        if($(this).text().toUpperCase().indexOf(val.toUpperCase()) != -1){
            $(this).removeClass('hideContent');
        }
        else {
            $(this).addClass('hideContent');
        }

     });

    if($('.content-block:not(#noResults):not(#contactForm):not(.hideContent)').length <= 0) {
        $('#noResults').removeClass('hideContent');
    }
    else {
        $('#noResults').addClass('hideContent');
    }
    }
}

resizeFAQ();

// Event Listeners

window.addEventListener('resize', function(event) {
    resizeFAQ();
}, true);

$('.content-block-content').click(function(e) {
    e.stopPropagation();
});

$( "#help_search" ).on("input", function() {
    updateInputAndSearch($(this))
});

$('#back-to-main').click(function(e) {
    scrollToTop();
    backToMain();
});

$('.content-block').click(function(e) {
    openFaq($(this))
})

$('.category-item-main').click(function(e) {

    let newCategoryHandle = $(this).attr('data-category');

    if(newCategoryHandle == 'e-guides') {
      window.location.href = "/pages/e-guides";
      return;
    }
  
    scrollToTop();
    showCategoryView();
});

$('.help-center-button,.category-item-main').click(function(e) {

    let newCategoryHandle = $(this).attr('data-category');

    if(newCategoryHandle == 'e-guides') {
      window.location.href = "/pages/e-guides";
      return;
    }
  
    changeCategory($(this));
});

// Open one category from the URL: /pages/help?category=returns
//
// Added 2026-08-16 for the HubSpot help-centre retirement. The six articles at
// help.zumanutrition.com die with that account on 2026-10-08 and are 301'd here,
// but the redirect can only carry a URL — without this the customer lands on
// "All FAQs" and has to hunt for the answer they just clicked on.
//
// The handles are the real data-category values on this page, which Liquid
// produces with `| handle`: lowercase, digits and hyphens only. Anything else
// came from somewhere other than our own markup, so it is ignored rather than
// interpolated — a stray quote would break the attribute selector and throw,
// taking the rest of this listener (including the ?eguide= redirect) with it.
//
// Silent when the category does not exist. The page still renders All FAQs,
// which is what these links did before this existed: they degrade, they do not
// break.
function openCategoryFromQuery() {
    var handle = new URLSearchParams(window.location.search).get('category');
    if (!handle || !/^[a-z0-9-]{1,64}$/.test(handle)) return false;

    var item = $('.category-item-main[data-category="' + handle + '"]');
    if (item.length === 0) return false;

    item.first().click();
    return true;
}

  document.addEventListener("DOMContentLoaded", (event) => {
    if (window.location.href.indexOf("?contact=true") > -1) {
        $('.category-item-main[data-category="contact"]').click();
    }
    else {
        openCategoryFromQuery();
    }

      if (window.location.href.indexOf("?eguide=true") > -1) {
        window.location.replace("/pages/e-guides");
      }


});